// The portfolio's header, as on its home: local time left, the logo and
// "The design office of Tiago Nascimento" in the middle. It sits under the
// menu's blur.
import * as React from "react"
import { t } from "./i18n"
import { go } from "./route"

// the NTO wordmark, hosted with the portal (from the portfolio's own mark)
const LOGO = "/nto-logo.svg"

function useClock() {
    const fmt = () =>
        new Intl.DateTimeFormat("en-GB", { hour: "2-digit", minute: "2-digit", timeZone: "Europe/Amsterdam" }).format(new Date())
    const [time, setTime] = React.useState(fmt)
    React.useEffect(() => {
        const id = window.setInterval(() => setTime(fmt()), 15000)
        return () => window.clearInterval(id)
    }, [])
    return time
}

/** home: where the logo leads (the studio's client list, or the client's projects) */
export function Header({ home }: { home?: string }) {
    const time = useClock()
    return (
        <header className="p-header">
            <div className="p-clock">
                <span>{t("Local time")}</span>
                <span>{time}</span>
            </div>
            <a
                className="p-brand"
                href={home || "https://nascimen.to"}
                aria-label="NTO, home"
                onClick={(e) => {
                    if (!home || e.metaKey || e.ctrlKey) return
                    e.preventDefault()
                    if (location.pathname !== home) go(home)
                }}
            >
                <img className="p-logo" src={LOGO} alt="NTO" />
                <span className="p-sig">
                    <span>The design office</span>
                    <span>of Tiago Nascimento</span>
                </span>
            </a>
        </header>
    )
}
